import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefundService } from 'src/app/_services/refund.service';
import { ConfirmCancelPaymentComponent } from './confirm-cancel-payment/confirm-cancel-payment.component';
import { AlertService } from 'src/app/_alert';

@Component({
  selector: 'app-cancel-payment',
  templateUrl: './cancel-payment.component.html',
  styleUrls: ['./cancel-payment.component.css']
})
export class CancelPaymentComponent implements OnInit {

  constructor(
    public dialog: MatDialog, public dialogRef: MatDialogRef<CancelPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public refundService: RefundService,
    public alertService : AlertService
  ) { }

  submitted: any = false;
  reason: any = [];
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  ngOnInit(): void {
    this.refundService.refundReason().subscribe((response) => {
      console.log(response);
      this.reason = response;
    })
    console.log(this.data);
  }

  cancelPaymentForm = new FormGroup(
    {
      trackingNo: new FormControl(this.data.TrackingNo, [Validators.required]),
      afsTransactionId: new FormControl(this.data.AFSTransactionId, [Validators.required]),
      agentId: new FormControl(this.data.agentId, [Validators.required]),
      reasonCode: new FormControl(''),
      comment: new FormControl(''),
    }
  )

  get forms() {
    return this.cancelPaymentForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.cancelPaymentForm.valid) {
      console.log(this.data);
      const dialogRef = this.dialog.open(ConfirmCancelPaymentComponent, {
        width: '500px',
        disableClose: true,
        data: { cancelData: this.cancelPaymentForm.value }
      });
      this.dialogRef.close();
    }
    else {
      console.log("Error!!Please enter valid data.");
      this.alertService.error("Error!!Please enter valid data.", this.options);
    }

  }

  onNoClick() {
    this.dialogRef.close();
  }

}
